import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { formatRut, validateRut } from 'rutlib';
import { AuthGoogleService } from '../service/auth-google.service';
import { ClientUser } from '../interface/user.interface';
import { MatAccordion } from '@angular/material/expansion';
import Swal from 'sweetalert2';
import { ConfigRutService } from 'src/app/services/config-rut.service';

@Component({
  selector: 'app-side-login',
  styleUrls: ['./side-login.component.scss'],
  templateUrl: './side-login.component.html',
})
export class AppSideLoginComponent {
  userRut: number = 0;
  validateRut: boolean = false;
  passConfirm: any;
  user: ClientUser = null;

  @ViewChild(MatAccordion) accordion: MatAccordion;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private AuthGoogle: AuthGoogleService,
    private authService: AuthService,
    private serviceRut: ConfigRutService
  ) {
  }

  ngOnInit() {
    if(localStorage.getItem('token') != null) {
      this.router.navigateByUrl('/dashboards');
    }
    //this.setToken();
  }

  setToken() {
    //const token = sessionStorage.getItem('token');
    const token = localStorage.getItem('token');
    if (token) {
      this.router.navigateByUrl('/dashboards');
    }
  }

  UserForm = new FormGroup({
    rutUser: new FormControl<string | null>('', [Validators.required]),
    passwordUser: new FormControl<string | null>('', [Validators.required]),
  });

  UserSiiForm = new FormGroup({
    rutEmpresa: new FormControl<string | null>('', [Validators.required]),
    passwordSii: new FormControl<string | null>('', [Validators.required]),
  });

  loginGoogle() {
    this.AuthGoogle.loginGoogle();
  }

  inputRut(rut2: any, fieldName: any): void {
    let rut: string = rut2.target.value;
    let rutClient: any;
    const formattedRut: string = formatRut(rut);

    if (fieldName == 'rutUser') {
      rutClient =
        this.UserForm.controls['rutUser'].setValue(formattedRut);
      if (rutClient >= 30000000) {
        this.UserForm.controls['rutUser'].setErrors({
          incorrect: true,
        });
      }
    }

    if (fieldName == 'rutEmpresa') {
      rutClient =
        this.UserSiiForm.controls['rutEmpresa'].setValue(formattedRut);
      if (rutClient < 30000000) {
        this.UserSiiForm.controls['rutEmpresa'].setErrors({
          incorrect: true,
        });
      }
    }

    const cleanedRutWithoutDots = rut.replace(/\./g, '');
    this.userRut = parseInt(
      cleanedRutWithoutDots.substring(0, cleanedRutWithoutDots.length - 1)
    );

    this.validateRut = validateRut(rut);
  }

  get fc() {
    return this.UserForm.controls;
  }

  get f() {
    return this.UserSiiForm.controls;
  }

  open() {
    this.router.navigateByUrl('/dashboards');
  }

  submit() {
    const rut = this.userRut.toString();

    if(this.UserForm.valid) {
      this.user = {
        rut: this.serviceRut.transformStringRut(this.UserForm.value.rutUser).toString(),
        password: this.UserForm.value.passwordUser,
        passwordSii: '',
        oAuth2GoogleToken: '',
        email: ''
      };
    }
    if(this.UserSiiForm.valid) {
      this.user = {
        rut: this.serviceRut.transformStringRut(this.UserSiiForm.value.rutEmpresa).toString(),
        password: '',
        passwordSii: this.UserSiiForm.value.passwordSii,
        oAuth2GoogleToken: '',
        email: ''
      };
    }

    Swal.fire({
      text: 'Estamos validando tus credenciales',
      icon: 'question',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
          this.authService.login(this.user).subscribe({
            next: (data) => {
              this.authService.setToken(data.token);
              //const pass = this.authService.changePass();
              var isUserClient = this.authService.getUserType();
              var changuePass = this.authService.changePass();
              var companiesAssocied = this.authService.getCompaniesAssocied();
              if(isUserClient=="True") {
                sessionStorage.setItem("timeInSession", new Date().toISOString());
                if(changuePass) {
                  this.router.navigateByUrl('/dashboards/cliente/meInfo');
                  Swal.close();
                }
                else {
                  if(companiesAssocied.length > 1 || companiesAssocied == null || companiesAssocied.length == 0){
                    this.router.navigateByUrl('/dashboards/cliente/companies');
                    Swal.close();
                  }
                  else {
                    this.authService.setItemSession('companieSelected', companiesAssocied)
                    this.router.navigateByUrl('dashboards/cliente/dashboard?company=' + companiesAssocied);
                    Swal.close();
                  }
                }
              }
              else {
                this.authService.getUserType();
                this.router.navigateByUrl('/dashboards');
                Swal.close();
              }
            },
            error: (err) => {
              Swal.fire({
                title: 'Error',
                text: 'El rut y/o la contraseña, son incorrectas',
                icon: 'error',
              });
              this.router.navigate(['/login']);
            },
          });
      },
    });
  }
}